import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component Tabs để chuyển đổi giữa các tab
 * @param {Array} items - Danh sách tên các tab
 * @param {number} activeIndex - Index của tab đang active
 * @param {Function} onChange - Callback khi thay đổi tab
 * @param {string} className - Class CSS tùy chỉnh
 */
export default function Tabs({items = [], activeIndex = 0, onChange, className = ''}) {
    return (
        <div className={`tabs-container ${className}`}>
            {items.map((tab, index) => (
                <button
                    key={index}
                    className={`tab-item ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => onChange(index)}>
                    {tab}
                </button>
            ))}
        </div>
    );
}

Tabs.propTypes = {
    items: PropTypes.arrayOf(PropTypes.string).isRequired,
    activeIndex: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};
